<script lang="ts">
    import FeatherIcon from "svelte-feather-icon";
    import {Notification} from "../../Data/Layout/Header";
    import { Notifications, Youhave } from "../../utils/Constant/Constant";
    import { Badge } from "sveltestrap";
</script>

<li class="onhover-dropdown">
    <div class="notification-box">
        <FeatherIcon icon="bell" /><span class="dot-animated" />
    </div>
    <ul class="notification-dropdown onhover-show-div">
        <li>
            <p class="f-w-700 mb-0">{Youhave} 3 {Notifications}
                <Badge color="primary" pill class="pull-right">4</Badge >
            </p>
        </li>
        {#each Notification as notificationItem}
            <li class="noti-primary">
                <div class="media">
                    <span class="notification-bg {notificationItem.color}">
                        <FeatherIcon icon={notificationItem.Icon} />
                    </span>
                    <div class="media-body">
                        <p>{notificationItem.Detail}</p>
                        <span>{notificationItem.Time}</span>
                    </div>
                </div>
            </li>
        {/each}
    </ul>
</li>
